import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/layout/MainLayout'
import Load from '@/pages/load/index'
import store from '@/store/index'

const AsyncComponent = (__module__, __name__) => () => import(`@/pages/${__module__}/${__name__}`)

Vue.use(Router)

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: '/load',
            component: MainLayout,
            children: [
                {
                    path: '/home',
                    meta: {
                        title: '首页'
                    },
                    component: AsyncComponent('home', 'index'),
                    children: []
                },
                {
                    path: '/distribution',
                    meta: {
                        title: '共享'
                    },
                    component: AsyncComponent('distribution', 'index')
                },
                {
                    path: '/help',
                    meta: {
                        title: '帮助中心'
                    },
                    component: AsyncComponent('help', 'index')
                },
                {
                    path: '/user',
                    meta: {
                        title: '用户中心'
                    },
                    component: AsyncComponent('user', 'index')
                }
            ]
        },
        {
            path: '/useraddress',
            meta: {
                title: '地址管理'
            },
            component: AsyncComponent('user', 'address')
        },
        {
            path: '/useredit',
            meta: {
                title: '个人资料'
            },
            component: AsyncComponent('user', 'edit')
        },
        {
            path: '/userorder',
            meta: {
                title: '我的订单'
            },
            component: AsyncComponent('order', 'index')
        },
        {
            path: '/shop',
            component: AsyncComponent('shop', 'index'),
            children: [
                {
                    path: 'goods',
                    meta: {
                        title: '商品详情'
                    },
                    component: AsyncComponent('shop', 'goods')
                },
                {
                    path: 'list',
                    meta: {
                        title: '商城'
                    },
                    component: AsyncComponent('shop', 'goodslist')
                }
            ]
        },
        {
            path: '/pay',
            meta: {
                title: '订单支付'
            },
            component: AsyncComponent('order', 'pay')
        },
        {
            path: '/order-detail',
            meta: {
                title: '订单详情'
            },
            component: AsyncComponent('order', 'detail')
        },
        {
            path: '/inviters',
            meta: {
                title: '名片分享统计'
            },
            component: AsyncComponent('distribution', 'inviters')
        },
        {
            path: '/inviterOrders',
            meta: {
                title: '业务订单'
            },
            component: AsyncComponent('distribution', 'inviterOrders')
        },
        {
            path: '/commission',
            meta: {
                title: '收益明细'
            },
            component: AsyncComponent('distribution', 'commission')
        },
        {
            path: '/withdrawal-log',
            meta: {
                title: '提现明细'
            },
            component: AsyncComponent('distribution', 'withdrawal')
        },
        {
            path: '/load',
            meta: {
                title: '加载'
            },
            component: Load
        },
        {
            path: '/share',
            meta: {
                title: '分享'
            },
            component: AsyncComponent('distribution', 'share')
        },
        {
            path: '/commission-top',
            meta: {
                title: '名片分享排行榜'
            },
            component: AsyncComponent('distribution', 'commissionTop')
        },
        {
            path: '/inviter-top',
            meta: {
                title: '名片分享排行'
            },
            component: AsyncComponent('distribution', 'inviterTop')
        },
        {
            path: '/help-content',
            meta: {
                title: '协议内容'
            },
            component: AsyncComponent('help', 'content')
        }
    ]
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
    Vue.$vux.loading.hide()
    if (!sessionStorage.getItem('x-token')) {
        let s = window.location.search.replace('?', '')
        s = Vue.qs.parse(s)
        if (to.path === '/load') {
            next()
        } else {
            if ('store_id' in s) {
                let url = '//wx.jiuyiyishu.com/wxapi/index/wxlogin?store_id=' + s.store_id
                // let url = '//testapi.jiuyiyishu.com/wxapi/index/wxlogin?store_id=' + s.store_id
                if ('inviter_id' in s) {
                    url += '&inviter_id=' + s.inviter_id
                }
                window.location.href = url
            } else {
                next({
                    path: 'load'
                })
            }
        }
    } else {
        store.commit('updateLoadingStatus', {isLoading: true})
        if (!to.query.store_id) {
            to.query.store_id = from.query.store_id
            next({
                path: to.path,
                query: to.query
            })
        } else {
            next()
        }
    }
})

router.afterEach(function (to) {
    store.commit('updateLoadingStatus', {isLoading: false})
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js